var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCourseMetaCredits = function SvgIconCourseMetaCredits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1L1 3V36L19 47L37 36V3L19 1Z",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19L19 30L37 19L19 8L1 19Z",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 27.2798L19 33.9998",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.5601L30 23.2801",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.5601L26.72 25.2801",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 24.5601L23.46 27.2801",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 31.2798L19 37.9998",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23.2798V31.2798L19 37.9998V29.9998",
    stroke: "#A6956A",
    strokeWidth: 1.14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconCourseMetaCredits;